export enum ClaimInsuranceTab {
  Documents = 'documents',
  Insurance = 'insurance'
}
